import React, { useState, useEffect } from 'react'
import Feeds from '../features/feeds/Feeds'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { api } from '../app/Api/ApiSlice'
import UserImage from "../assets/user.png"
import officeImg from "../assets/office.png"
import { FaPen } from 'react-icons/fa'


const Homepage = () => {
    const [favouriteStores, setFavouriteStores] = useState([])
    const [homeFriendRequests, setHomeFriendRequests] = useState([])

    const userInfo = useSelector((state) => state.auth.user)


    const navigate = useNavigate()

    useEffect(() => {
        const getHomeSuggestions = async () => {
            try {
                const response = await api.get("/feeds/suggestions")
                if (response) {
                    setFavouriteStores(response.data?.stores)
                    setHomeFriendRequests(response.data?.friendRequests)
                }
            } catch (error) {
            }
        }
        getHomeSuggestions()
    }, [])

    return (
        <div className="page">
            <div className="page-body home-page">
                <div className="home-page-userdetails">
                    <div className=''>
                        <h2 className="content-header">Profile</h2>
                        <div className="userdata">
                            <img src={userInfo.user?.profilePic ? userInfo?.user?.profilePic : UserImage} alt="" className="home-user-image" />
                            <h3 className="username">{userInfo?.user?.firstname} {userInfo?.user?.lastname}</h3>
                            <div className="profile-edit-btn" onClick={() => navigate(`/profile/edit`, { state: { user: userInfo } })}>
                                <button>  <FaPen /> Edit</button>
                            </div>
                        </div>
                        <div className="user-community">
                            <Link to="/profile/friends/">
                                <p className="community">{`Friends (${userInfo ? userInfo.user?.friendsCount : 0})`}</p>
                            </Link>
                            <Link to="/profile/friend-requests/">
                                <p className="community">{`Friends requests (${userInfo ? userInfo.user?.receivedFriendRequests : 0})`}</p>
                            </Link>
                            <Link to="/profile/followers/">
                                <p className="community">{`Followers (${userInfo ? userInfo.user?.followers : 0})`}</p>
                            </Link>
                            <Link to="/profile/followings/">
                                <p className="community">{`Followings (${userInfo ? userInfo.user?.followings : 0})`}</p>
                            </Link>
                            <Link to="/chats">
                                <p className="community">{`Messages`}</p>
                            </Link>
                        </div>
                    </div >
                </div>
                <div className="homepage-content">
                    <Feeds />
                </div>
                <div className="homepage-suggestions">
                    <div className=''>

                        {homeFriendRequests &&
                            <div className="home-friend-requests">
                                <h2>Friend Requests</h2>
                                {homeFriendRequests.length === 0 && <p>No friend requests</p>}
                                {
                                    homeFriendRequests.map((request, i) => (
                                        <div className="home-friend-request" key={i}>
                                            <img src={request?.profilePic?.url} alt='' />
                                            <div className="request-details">
                                                <p>{request.username}</p>
                                                <div className="request-actions">
                                                    <button>Accept</button>
                                                    <button>Decline</button>
                                                    <button>About</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                                <button className="homepage-btns" onClick={() => navigate(`/profile/friend-requests/suggested`)}>see more</button>
                            </div>
                        }
                        <div className="home-stores">
                            {favouriteStores &&
                                <div>
                                    <h2>Businesses</h2>
                                    <div className="home-stores-items">
                                        {
                                            favouriteStores.map((favStore) => (
                                                <div className="home-store" key={favStore._id}>
                                                    <div className="" onClick={() => navigate(`/b/${favStore.name}`, { state: { storeData: favStore } })}>
                                                        <img src={favStore.banner?.url ? favStore?.banner?.url : officeImg} alt="" />
                                                        <h3 className="home-store-name">{favStore.name}</h3>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            }
                            <button className="homepage-btns" onClick={() => navigate("/b")}>see more</button>
                        </div>
                    </div >
                </div>
            </div>
        </div>
    )
}

export default Homepage